module.exports = __webpack_public_path__ + "img/pic9.5bec06a7.png";